import { type ApiSchemas, shopwareApiClient } from '$lib/api/shopwareApi';
import type { ShopContext } from '$lib/context';

export class MediaApi {
    public static getMedia(
        data: { ids: string[] },
        shopContext: ShopContext,
        fetchImplementation?: typeof fetch
    ): Promise<ApiSchemas['Media']> {
        return shopwareApiClient.invoke('media post /media', data, {
            fetchImplementation,
            shopContext
        });
    }
}
